import h from 'hyperscript';
import { throttle } from 'lodash';
import { BREAKPOINTS } from 'javascripts/constants/index';
import generateIcon from 'components/_particles/icon/icon';
import Slider from 'javascripts/globals/slider';

class ItemSlider extends Slider {
  initSlider() {
    this.slidesToShow = 1;
    this.mqls = [
      window.matchMedia(`(min-width: ${BREAKPOINTS.l})`),
      window.matchMedia(`(min-width: ${BREAKPOINTS.xl})`),
    ];

    this.initClasses();

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < this.mqls.length; i++) {
      this.setSlidesToShow(this.mqls[i]);
      // this.mqls[i].addListener(this.setSlidesToShow());
      // this.mqls[i].addEventListener('change', this.setSlidesToShow(this.mqls[i]));
    }

    this.$sliderItems.forEach(($slide, index) => {
      if (index === 0) {
        $slide.classList.add(`${this.options.sliderItemActive}`);
      }
    });

    if (this.options.buttons === true && this.$sliderItems.length > 1) {
      this.initButtons();
    }

    if (this.options.dots === true && this.$sliderItems.length > 1) {
      this.initDots();
    }

    this.$sliderFrame.addEventListener('scroll', throttle(this.runOnScroll, 250));
  }

  setSlidesToShow() {
    if (this.mqls[0].matches) {
      this.slidesToShow = 2;
    }

    if (this.mqls[1].matches) {
      this.slidesToShow = 3;
    }
  }

  runOnScroll(e) {
    const $sliderButtonPrev = e.target.querySelector('.slider__button--prev');
    const $sliderButtonNext = e.target.querySelector('.slider__button--next');
    const sliderFrameScrollLeft = e.target.scrollLeft;
    const sliderFrameScrollLeftMax = e.target.scrollLeftMax;

    if (sliderFrameScrollLeft <= 40) {
      $sliderButtonPrev.classList.add('slider__button--hidden');
    } else {
      $sliderButtonPrev.classList.remove('slider__button--hidden');
    }

    if (sliderFrameScrollLeft >= (sliderFrameScrollLeftMax - 40)) {
      $sliderButtonNext.classList.add('slider__button--hidden');
    } else {
      $sliderButtonNext.classList.remove('slider__button--hidden');
    }
  }

  onButtonClick(e) {
    const currScrollLeft = this.$sliderFrame.scrollLeft;
    const sliderItemWidth = this.$sliderItems[0].clientWidth;
    const sliderButtonNext = e.currentTarget.classList.contains('slider__button--next');

    let scrollAmount = currScrollLeft - (sliderItemWidth * this.slidesToShow);
    if (sliderButtonNext) { scrollAmount = currScrollLeft + (sliderItemWidth * this.slidesToShow); }

    this.$sliderFrame.scroll({
      left: scrollAmount,
      behavior: 'smooth',
    });
  }

  createButton(position) {
    const buttonClasses = [
      this.classes.sliderButton,
      `${this.classes.sliderButton}--${position}`,
      position === 'prev' && `${this.classes.sliderButton}--hidden`,
    ];

    // Button element
    const $button = h(`button.${buttonClasses.join('.')}`, {
      attrs: {
        type: 'button',
        'aria-hidden': this.options.tabbableSlides && true,
        tabindex: this.options.tabbableSlides ? -1 : 0,
      },
    }, [generateIcon({
      icon: position === 'prev' ? this.options.iconPrev : this.options.iconNext,
      classes: [`${this.classes.sliderButton}-icon`],
    })]);

    $button.addEventListener('click', this.onButtonClick.bind(this));

    return $button;
  }

  initButtons() {
    const $buttonFrame = h(`div.${this.classes.sliderButtonFrame}`);

    // Append specific button elements
    $buttonFrame.append(this.createButton('prev'));
    $buttonFrame.append(this.createButton('next'));

    this.$sliderFrame.append($buttonFrame);
  }

  onDotClick(e) {
    const dotPosition = e.currentTarget.dataset.position;
    const sliderFrameScrollLeftMax = this.$sliderFrame.scrollLeftMax;
    const deltaScrollLeft = sliderFrameScrollLeftMax / (this.noDots - 1);
    const scrollAmount = dotPosition * deltaScrollLeft;

    this.$sliderFrame.scroll({
      left: scrollAmount,
      behavior: 'smooth',
    });
  }

  initDots() {
    // Create dot list
    this.$sliderDotList = h(`ul.${this.classes.sliderDotFrame}-list`);
    this.noDots = Math.floor(this.$sliderItems.length / this.slidesToShow);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < this.noDots; i++) {
      const $sliderDot = h(`li.${this.classes.sliderDotFrame}-item`,
        h(`button.${this.classes.sliderDot}`, {
          attrs: {
            type: 'button',
            'aria-current': (i === 0) && 'true',
            'data-position': i,
          },
        },
        h('span.u-hidden-visually', `${this.options.controlText} ${i + 1}`)));

      $sliderDot.querySelector(`.${this.classes.sliderDot}`).addEventListener('click', this.onDotClick.bind(this));
      this.$sliderDotList.append($sliderDot);
    }

    this.$sliderFrame.addEventListener('scroll', () => {
      // Get index number of the most visible slide
      const visibleSlideIndex = Math.round(
        this.$sliderFrame.scrollLeft / this.$sliderFrame.clientWidth,
      );

      // Mark corresponding slider dot if slide is visible
      this.switchDot(
        this.$sliderDotList.childNodes[visibleSlideIndex].lastElementChild,
      );
    }, { passive: true });

    // Create dot wrapper
    this.$sliderDotFrame = h(`nav.${this.classes.sliderDotFrame}`, this.$sliderDotList);

    // Append dot frame
    this.$el.append(this.$sliderDotFrame);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-item-slider').forEach(
    $slideshow => new ItemSlider($slideshow, {
      sliderFrame: 'item-slider__items',
      sliderItem: 'item-slider__item',
    }),
  );
});
